/*
Purpose:
Sidebar navigation used in dashboard layouts.

Provides quick access to major sections:
• Dashboard
• Campaigns
• Analytics
• Payments

This component will be reused in:
Company Dashboard
Creator Dashboard
Admin Dashboard
*/

export default function Sidebar() {
  return (
    <div className="w-64 bg-yellow-400 shadow-lg p-6">

      <h2 className="text-xl text-black font-bold mb-8">
        Business Panel
      </h2>

      <nav>
        <ul className="  space-y-4">

          <li className="cursor-pointer text-balck hover:text-blue-500">
            Dashboard
          </li>

          <li className="cursor-pointer text-balck hover:text-blue-500">
            Campaigns
          </li>

          <li className="cursor-pointer text-balck hover:text-blue-500">
            Analytics
          </li>

          <li className="cursor-pointer text-balck hover:text-blue-500">
            Payments
          </li>

        </ul>
      </nav>

    </div>
  );
}